<template>
  <div class="pre-req" style="margin-bottom: 100px;height: fit-content;overflow: auto;    height: 90vh;" dir="rtl">
    <div class="">
      <div
        ref="form"
      >
        <div class="page-title">
          {{request_info.RequestName}}
        </div>
        <ul class="relative">
          <li cols="12" class="">
            <label>{{ $t('lastStatus') }}</label>
            <span>
                {{request_info.LastStatus}}
              </span>
          </li>

          <li cols="12" class="">
            <label>{{ $t('requestNumber') }}</label>
            <span>
                {{request_info.RequestCode}}
              </span>
          </li>

          <li cols="12" class="">
            <label>{{ $t('registerDate') }}</label>
            <span>
                {{request_info.RequestTime}}
              </span>
          </li>

          <li cols="12" class="">
            <label>{{ $t('description') }}</label>
            <span>
                {{request_info.Summary}}
              </span>
          </li>

          <li cols="12" class="relative">
            <label>{{ $t('phoneNO') }}</label>
            <span>
                  {{request_info.CustomerMobile}}
              </span>
            <a :href="'tel:'+request_info.CustomerMobile" class="call-btn">
              <v-icon>
                mdi-phone
              </v-icon>
            </a>
          </li>
          <li cols="12" class="relative" v-if="request_info.OtherPhoneNO != null">
            <label>{{ $t('secoundPhoneNo') }}</label>
            <span>
                  {{ request_info.OtherPhoneCode+request_info.OtherPhoneNO}}
              </span>
<!--            <a :href="'tel:'+request_info.OtherPhoneCode+request_info.OtherPhoneNO" class="call-btn">-->
<!--              <v-icon>-->
<!--                mdi-phone-->
<!--              </v-icon>-->
<!--            </a>-->
          </li>

          <li cols="12" class="">
            <label>{{ $t('referDescription') }}</label>
            <span>
                {{request_info.StatusSummary}}
              </span>
          </li>
          <hr>
          <li v-if="request_info.EjraiStatusSummary!=null">
            <label>وضعیت های اجرائی</label>

            <div v-for="ejraii in JSON.parse(request_info.EjraiStatusSummary)">
              {{ejraii.StatusName}} : {{ejraii.Summary}}
            </div>

          </li>
        </ul>
        <v-row>
          <v-col cols="12" class="pa-4 pt-1">
            <label>{{ $t('addresses') }}</label>
            <div v-for="item_address in request_info.Addresses">
              <div class="addresses">
                <div>
                  <div class="flex-no-wrap justify-space-between">
                    <div>

                      <p>{{get_request_address(item_address)}}</p>
                      <div v-text="item_address.PhoneCode+item_address.PhoneNO" class="address-phone"></div>
                      <label v-if="item_address.FromTime !=null">{{item_address.FromTime}} -
                        {{item_address.ToTime}}
                      </label>
                      <div class="pt-3 text-center">

                        <v-btn

                          v-if="item_address.Lat !=null"
                          class="ml-2"
                          outlined
                          rounded
                          color="primary"
                          v-on:click="go_direction(item_address,1)"
                        >{{ $t('navigation') }}</v-btn>
                        <v-btn

                          v-if="item_address.Lat !=null"
                          class="ml-2"
                          outlined
                          rounded
                          color="primary"
                          v-on:click="go_direction(item_address,3)"
                        >مسیریابی نشان</v-btn>
                        <v-btn

                          v-if="item_address.Lat !=null"
                          class="ml-2"
                          outlined
                          rounded
                          color="primary"
                          v-on:click="go_direction(item_address,2)"
                        >مسیریابی ویز</v-btn>
<!--                        <a :href="'tel:'+item_address.PhoneCode+item_address.PhoneNO" class="call-phone">-->
<!--                          <v-icon>-->
<!--                            mdi-phone-->
<!--                          </v-icon>-->
<!--                        </a>-->
                      </div>
                    </div>

                  </div>

                </div>

              </div>

            </div>

          </v-col>
        </v-row>
        <v-row>

          <v-btn class="width-100-p" color="primary"  v-on:click="dialog_change_pre_req_status=true">
            تغییر وضعیت درخواست
          </v-btn>
          <button class="btn start-to-go-btn" v-if="action_button_text != ''" v-on:click="go_to_categories()">
            {{action_button_text}}
          </button>


        </v-row>

        <v-dialog  class="" v-model="dialog_service_out_branch" >
          <v-card class="dialog1-card">
            <div class="text-center dialog-header">
          <span class="name">{{ $t('requestStatus') }}</span>

            </div>
            <v-card-text>
              <v-container>
                <div >{{ $t('isRequestInBranchOrNot') }}</div>

              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="mr-5 ml-5 btn-info save-btn" text @click="service_out_branch_action(8)">{{ $t('inLocation') }}</v-btn>
              <button class="btn-success save-btn" @click="service_out_branch_action(7)">{{ $t('inBranch') }}</button>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog  class="" v-model="dialog_change_pre_req_status" >
          <v-card class="dialog1-card">
            <div class="text-center dialog-header">
          <span class="name">تغییر وضعیت درخواست</span>

            </div>
            <v-card-text>
              <v-container>
<v-select
  :items="pre_req_status_list"
  v-model="selected_pre_req_status"
  item-text="StateName"
  item-value="Id"
/>
                <v-text-field
  :items="pre_req_status_list"
  v-model="pre_req_status_summary"
  placeholder="توضیحات وضعیت"
/>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="mr-5 ml-5 btn-info save-btn" text @click="change_pre_request_status_tech()">ثبت وضعیت</v-btn>
              <button class="btn-success save-btn" @click="dialog_change_pre_req_status=false">انصراف</button>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog  class="" v-model="dialog_accept_refer"
                   fullscreen
                   hide-overlay>
          <v-card class="dialog1-card">
            <div class="text-center dialog-header">
              <span class="name">درخواست ارجاعی</span>

            </div>
            <v-card-text>
              <v-container>
                آیا دریافت این درخواست ارجاعی را تایید میکنید؟
                <v-text-field
                  v-model="req_tech_refer_summary"
                  placeholder="توضیحات"
                />
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="mr-5 ml-5 btn-info save-btn" text @click="accept_refer_tech(1)">قبول ارجاع درخواست</v-btn>
              <v-btn class="mr-5 ml-5 btn-info save-btn" text @click="accept_refer_tech(0)">رد ارجاع درخواست</v-btn>
              <button class="btn-success save-btn" @click="$router.go(-1)">انصراف</button>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </div>

    </div>
  </div>
</template>
<script>
  import { bus } from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        errors: [],
        request_info: [],
        request_statuses: [],
        pre_req_status_summary: "",
        selected_pre_req_status: 0,
        dialog_change_pre_req_status: false,
        req_tech_refer_summary: "",
        dialog_accept_refer: false,
        pre_req_status_list: [],
        action_button_text: '',
        next_action_status: 0,
        dialog_service_out_branch: false,
        technician_name: 'hamid mokhtari',
        device_password: 'hamid mokhtari',

        current_lat:'',
        current_lng:'',
        source_location_lat:'',
        source_location_lng:'',
      }
    },
watch: {
      selected_province: function () {
        this.get_cities()
      }
    },
mounted () {
  this.get_current_location()

  // var passing_data = JSON.parse(localStorage.getItem('request_data'));
      // this.enable_send_from_country = passing_data.on_site_service;
      // this.get_phone_prefix()
      this.get_statuses()
      this.get_request_info()
      // this.get_provinces()
    },
    methods: {
      get_request_address (item) {
        var address = ''
        if (item.CityName != null) {
          address += item.CityName + ' ,'
        }
        if (item.AreaName != null) {
          address += item.AreaName + ' ,'
        }
        if (item.AddressText != null) {
          address += item.AddressText + ' '
        }

        return address
      },
      go_direction (item,state) {
        // var url = 'geo:0,0?q=' + item.Lat + ',' + item.Lng
        // var url = 'https://www.google.com/maps/@' + item.Lat +','+item.Lng+',17z'
        // var url = `https://waze.com/ul?ll=${item.Lat},${item.Lng}&z=10`
        var url = ""
        if(state==1){
          url = `https://maps.google.com/?q=${item.Lat},${item.Lng}`

        }
        if(state==2){
          url = `https://waze.com/ul?ll=${item.Lat},${item.Lng}&z=10`

        }
        if(state==3){
          url = `https://nshn.ir/?lat=${item.Lat}&lng=${item.Lng}`
        }
        window.open(url, '_blank')
      },
      get_request_info () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          IsFinalize: 0,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/UserReqDash', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.request_info = response.data.recordInfo
              self.get_device_status()
              self.$route.meta.name = self.$t('showPreRequest') + self.request_info.RequestCode

              if (self.request_info.سی == "0") {
                bus.$emit('show_toast', [3000, 'ارجاع درخواست توسط شما رد شده است'])
                self.$router.go(-1);
              }
              if (self.request_info.AcceptRefer == "10") {
                self.dialog_accept_refer = true;
              }
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_statuses () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          IsFinalize: 0,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetPreReqStatusForTech', send_data, {})
          .then(response => {
              self.pre_req_status_list = response.data.StatusList;
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_request_full_info () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          IsFinalize: 0,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetPreReqRecInfo', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // self.request_info = response.data.recordInfo;
              // self.get_device_status();
              var PassingData = { on_site_service: true }
              PassingData.ServiceOutBranch = response.data.recordInfo.ServiceOutBranch
              PassingData.ServiceOutBranchOnFinalize = '0'
              PassingData.PreRequestId = response.data.recordInfo.Id
              PassingData.on_site_service = true
              PassingData.cat_id = response.data.recordInfo.ProductTypeId
              PassingData.group_id = response.data.recordInfo.CategoryId
              PassingData.sub_group_id = response.data.recordInfo.GroupId
              PassingData.brand_id = response.data.recordInfo.SubGroupId
              PassingData.customer_summary = response.data.recordInfo.Description
              PassingData.model_id = response.data.recordInfo.ModelId
              PassingData.model_title = response.data.recordInfo.ModelTitle
              PassingData.other_phone_code = response.data.recordInfo.OtherPhoneCode
              PassingData.other_phone_no = response.data.recordInfo.OtherPhoneNO
              PassingData.customer_mobile = response.data.recordInfo.PhoneNO
              PassingData.customer_name = ''
              PassingData.stateId = 'final_pre_request'
              // data.put("typeId", String.valueOf(model.getRec().getProductTypeId()));
              // data.put("parentTitle", "درخواست");
              // data.put("stateId", "editrequest");
              // data.put("customer_name", "");
              // data.put("delivery_status", "true");
              PassingData.request_name = self.$t('repair')

              localStorage.setItem('request_data', JSON.stringify(PassingData))
              console.log(PassingData)
              if (PassingData.ServiceOutBranch == true) {
                self.dialog_service_out_branch = true
              } else {
                self.$router.push({ name: 'groups', params: {} })
              }
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      service_out_branch_action (type) {
// console.log(type,this.request_statuses);
        var data = JSON.parse(localStorage.getItem('request_data'))
        data.ServiceOutBranchOnFinalize = this.request_statuses[type]
        localStorage.setItem('request_data', JSON.stringify(data))

        this.$router.push({ name: 'groups', params: {} })
      },
      go_to_categories () {
        var has_exist = false
        var self = this
        // console.log("statuses is "+JSON.stringify(this.request_statuses));
        var has_exist = false
        self.request_statuses.forEach(function (number) {
          if (self.request_info.StatusId == number) {
            has_exist = true
          }
        })
        if (!has_exist) {
          self.action_button_text = this.$t('startDrive')
          self.next_action_status = self.request_statuses[0]
          self.get_last_user_location(this.next_action_status)

          return
        }

        if (self.request_info.StatusId == self.request_statuses[0]) {
          self.action_button_text = this.$t('acceptReceiveFromCustomer')
          self.next_action_status = self.request_statuses[1]
        }

        if (self.request_info.StatusId == self.request_statuses[1] || self.request_info.StatusId == self.request_statuses[16]) {
          self.action_button_text = this.$t('finalizeRequest')
          self.next_action_status = self.request_statuses[1]
          self.get_request_full_info()
          return false
        }

        this.change_request_status(this.next_action_status)
      },
      get_device_status () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetStatusSetting', send_data, {})
          .then(response => {
            self.request_statuses = response.data.rslt
            var has_exist = false
            self.request_statuses.forEach(function (number) {
              if (self.request_info.StatusId == number) {
                has_exist = true
              }
            })
            if (!has_exist) {
              self.action_button_text = self.$t('startDrive')
              self.next_action_status = self.request_statuses[0]
            } else if (self.request_info.StatusId == self.request_statuses[0]) {
              self.action_button_text = self.$t('acceptReceiveFromCustomer')
              self.next_action_status = self.request_statuses[1]
            } else if (self.request_info.StatusId == self.request_statuses[1] || self.request_info.StatusId == self.request_statuses[16]) {
              self.action_button_text = self.$t('finalizeRequest')
              self.next_action_status = self.request_statuses[1]
            } else {
              self.action_button_text = ''
              self.next_action_status = 0
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      change_request_status (status_id) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          Desc: '',
          StatusId: status_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ChangePreRequestStatus', send_data, {})
          .then(response => {
            self.get_request_info()
          }).catch(e => {
          this.errors.push(e)
        })
      },
      change_pre_request_status_tech () {
        if(this.selected_pre_req_status==0){
          bus.$emit('show_toast', [2000, "یک وضعیت انتخاب کنید"])

          return
        }
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
          PreReqId: this.$route.params.rec_id,
          Desc: this.pre_req_status_summary,
          StatusId: this.selected_pre_req_status,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddPreReqStatusByTech', send_data, {})
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.msg])
if(response.data.error==0){
  self.dialog_change_pre_req_status=false;
}
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_current_location(){
        // This will open permission popup
        var self =this
        navigator.geolocation.getCurrentPosition(function (position) {
          self.current_lat = position.coords.latitude;
          self.current_lng = position.coords.longitude;

        },function (error) {
          console.log('error location is',error)
        });
      },
      get_last_user_location(status) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId

        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetLastLocationByUserId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.source_location_lat = response.data.Lat;
              self.source_location_lng = response.data.Lng;
              // this.branch_id = response.data.UserBranchId
            }else{
              self.get_current_location();
              self.source_location_lat = self.current_lat;
              self.source_location_lng = self.current_lng;
            }
            self.get_snapp_price(status);

          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_snapp_price(status) {
        var self = this

        self.source_location_lat="35.732846"
        self.source_location_lng="51.373192"
        if(self.source_location_lat==null || self.source_location_lat==""){
          bus.$emit('show_toast', [1500, "موقعیت مکانی یافت نشد"])
          return
        }
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId

        // const send_data = {
        //   source_lat:self.source_location_lat,
        //   source_lng:self.source_location_lng,
        //   dest_lat:self.request_info.Addresses[0].Lat,
        //   dest_lng:self.request_info.Addresses[0].Lng
        // }
        var formData = new FormData();
        formData.append('source_lat',self.source_location_lat);
        formData.append('source_lng',self.source_location_lng);
        formData.append('dest_lat',self.request_info.Addresses[0].Lat);
        formData.append('dest_lng',self.request_info.Addresses[0].Lng);
        // console.log("send data snapp",send_data)
var url = 'https://cp.zoodkomak.com/api/get_user_locations_price';
        // var config = {
        //   method: 'post',
        //   url: url,
        //
        //   data : send_data
        // };

        this.axios.post(url,formData,{})
          .then(function (response) {
            console.log(response.data.time);
            self.change_request_status_with_price(status,response.data.time,response.data.distance);
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      change_request_status_with_price(status_id,price,distance) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          Desc: '',
          ReqType: 0,
          StatusId: status_id,
          SourceLat: self.source_location_lat,
          SourceLng: self.source_location_lng,
          DestLat: self.request_info.Addresses[0].Lat,
          DestLng: self.request_info.Addresses[0].Lng,
          RouteTime: price,
          Distance:distance,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ChangePreRequestStatusWithPrice', send_data, {})
          .then(response => {
            self.get_request_info()
            if (status_id == self.request_statuses[4]) {
              // GetSignature.open(getActivity(), req_id, "5", 0, "", "0", 0);
              self.$router.push({name: 'signature', params: {rec_id: self.$route.params.rec_id, type_id: 5}})
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },

      accept_refer_tech(status) {
        if(status==0&& this.req_tech_refer_summary==""){
          bus.$emit('show_toast', [2000, "توضیحات را وارد کنید"])
          return
        }
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ProcessId: this.$route.params.rec_id,
          RecStatusId: this.request_info.RecStatusId,
          ProcessType: 0,
          ItemDesc: this.req_tech_refer_summary,
          AcceptType: status,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddProcessReferAccept', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.get_request_info()
              self.dialog_accept_refer = false;
              if(status==0){
                self.$router.go(-1)
              }
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
  }
  }
</script>
